import { useRef } from "react";
import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { animeList } from "@/mocks/anime";

export default function HotPicks() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const top = [...animeList].sort((a, b) => b.rating - a.rating).slice(0, 6);

  function scroll(dir: number) {
    scrollRef.current?.scrollBy({ left: dir * 300, behavior: "smooth" });
  }

  return (
    <section id="recommand" className="py-14 md:py-20">
      <div className="container-x">
        <div className="flex items-end justify-between">
          <div>
            <span className="flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-fire-line"></i>
              本周热门
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              高分短番 · 一口气看完都不腻
            </h2>
            <p className="mt-2 max-w-lg text-sm text-foreground-600">
              评分最高的下饭番与摸鱼短番，短篇速刷不迷路，每一部都值得搬好小板凳一口气追完。
            </p>
          </div>
          <div className="hidden items-center gap-2 md:flex">
            <button
              type="button"
              onClick={() => scroll(-1)}
              aria-label="上一组"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:bg-background-200"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              type="button"
              onClick={() => scroll(1)}
              aria-label="下一组"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:bg-background-200"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="mt-8 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2"
          style={{ scrollbarWidth: "thin" }}
        >
          {top.map((anime) => (
            <div key={anime.id} className="w-44 shrink-0 snap-start sm:w-52 md:w-56">
              <AnimeCard anime={anime} />
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/biaoqian"
            className="btn-pill border border-primary-300 bg-background-50 text-primary-700 hover:bg-primary-100"
          >
            查看全部短番 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}